export default __webpack_public_path__ + "static/media/gen.cf3cae9f.png";